const base91Alphabet =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789" + '!#$%&()*+,./:;<=>?@[]^_`{|}~"';

const base91Lookup = Object.fromEntries([...base91Alphabet].map((c, i) => [c, i]));

export function base91encode(input: string) {
    const bytes = new TextEncoder().encode(input);

    let b = 0;
    let n = 0;
    let v;
    let output = "";

    for (const byte of bytes) {
        b |= byte << n;
        n += 8;

        if (n > 13) {
            v = b & 8191;

            if (v > 88) {
                b >>= 13;
                n -= 13;
            } else {
                v = b & 16383;
                b >>= 14;
                n -= 14;
            }

            output += base91Alphabet[v % 91];
            output += base91Alphabet[Math.floor(v / 91)];
        }
    }

    if (n) {
        output += base91Alphabet[b % 91];

        if (n > 7 || b > 90) {
            output += base91Alphabet[Math.floor(b / 91)];
        }
    }

    return output;
}

export function base91decode(input: string) {
    let b = 0;
    let n = 0;
    let v = -1;
    const bytes = [];

    for (const char of input) {
        const value = base91Lookup[char];

        if (value === undefined) {
            throw new Error(`Invalid Base91 character: ${char}`);
        }

        if (v < 0) {
            v = value;
        } else {
            v += value * 91;
            b |= v << n;

            if ((v & 8191) > 88) {
                n += 13;
            } else {
                n += 14;
            }

            do {
                bytes.push(b & 255);
                b >>= 8;
                n -= 8;
            } while (n > 7);

            v = -1;
        }
    }

    if (v >= 0) {
        b |= v << n;
        n += 7;

        while (n >= 8) {
            bytes.push(b & 255);
            b >>= 8;
            n -= 8;
        }
    }

    return new TextDecoder().decode(new Uint8Array(bytes));
}
